import { Button, Modal } from "flowbite-react";
import { useState } from "react";
import Select from "react-select";
import { useGetPaginatedCategoriesQuery } from "@/api/ticketApi/category";
import { Category } from "@/sharedTypes";
import { useTranslation } from "react-i18next";

interface CategoryListDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (categoryIds: number[]) => void;
  existingCategoryIds?: number[];
}

const CategoryListDialog = ({ open, onClose, onSubmit, existingCategoryIds = [] }: CategoryListDialogProps) => {
  const { t } = useTranslation(["group", "common", "category"]);
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const { data: categoriesData } = useGetPaginatedCategoriesQuery({
    pagination: { page: 1, pageSize: 100 },
    filters: {},
  });

  const options = (categoriesData?.items || [])
    .filter((cat: Category) => !existingCategoryIds.includes(cat.category_id))
    .map((cat: Category) => ({
      label: cat.category_name,
      value: cat.category_id,
    }));

  const handleSubmit = () => {
    onSubmit(selectedCategories);
    setSelectedCategories([]);
    onClose();
  };

  return (
    <Modal show={open} onClose={onClose} size="md">
      <Modal.Header>{t("group:addCategoryToGroup")}</Modal.Header>
      <Modal.Body className="overflow-visible">
        <div className="space-y-4">
          <Select
            isMulti
            options={options}
            onChange={(newValue) => setSelectedCategories(newValue.map((v: any) => v.value))}
            placeholder={t("group:selectCategories")}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
          <div className="flex justify-end gap-2">
            <Button color="failure" onClick={onClose}>{t("common:cancel")}</Button>
            <Button onClick={handleSubmit} disabled={selectedCategories.length === 0}>
              {t("group:addCategories")}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CategoryListDialog;
